<app-toast 
  *ngIf="toast.show" 
  [config]="toastConfig" 
  [show]="toast.show" 
  (hide)="hideToast()">
</app-toast>
<div
  class="layout-root"
  [ngClass]="{
    'sidebar-overlay': isOver,
    'sidebar-collapsed': !isOver && isCollapsed,
    'sidebar-expanded': !isOver && !isCollapsed
  }"
>
  <app-header
    class="fixed-header"
    [isCollapsed]="isCollapsed"
    (toggleCollapsed)="toggleCollapsed()"
    (toggleMobileNav)="sidenav.toggle()"
  ></app-header>

  <mat-sidenav-container
    class="mainWrapper blue_theme light-theme"
    autosize
    autoFocus
    dir="ltr"
  >
    <mat-sidenav
      #leftsidenav
      [mode]="isOver ? 'over' : 'side'"
      [opened]="!isOver"
      (openedChange)="onSidenavOpenedChange($event)"
      (closedStart)="onSidenavClosedStart()"
      class="sidebarNav fixed-sidenav"
      [class.collapsed]="!isOver && isCollapsed"
      [class.overlay-mode]="isOver"
    >
      <app-sidebar
        [sidenav]="leftsidenav"
        [isCollapsed]="!isOver && isCollapsed"
        (toggleMobileNav)="toggleSidenav()"
        (itemSelected)="onSidebarItemSelected($event)"
      ></app-sidebar>
    </mat-sidenav>

    <mat-sidenav-content class="contentWrapper">
      <!-- Optional: Add overlay when sidenav is open in mobile mode -->
      <div
        *ngIf="isOver && leftsidenav.opened"
        class="sidenav-backdrop"
        (click)="leftsidenav.close()"
      ></div>

      <main class="pageWrapper maxWidth">
        <router-outlet></router-outlet>
      </main>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>